import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

Vue.use(Buefy)
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Start',
    component: Index
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
